import React, { useEffect, useState } from "react";
import style from "./FocusZone.module.css";
import { baseurl } from "../Url";
import { useNavigate } from "react-router-dom";
import Loader from "../Loder/Loader";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import TargetIcon from "../../assests/Group 633.png"
import BookIcon from "../../assests/error_3730074 3.png"
import expand from "../../assests/expand.svg";
import collapse from "../../assests/collapse.svg";
import redBackArrow from "../../assests/redBackArrow.png"
import Study from "../../assests/study.png";


const FocusZone = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedModules, setExpandedModules] = useState(new Set());
  const [expandedTopics, setExpandedTopics] = useState(new Set());
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [selectedPracticeContext, setSelectedPracticeContext] = useState(null);
  const [lastAssessmentData, setLastAssessmentData] = useState(null);

  const fetchWeakStudents = async () => {
    const USERID = localStorage.getItem("USERID");
    const token = localStorage.getItem("access-token");
    const org_id = localStorage.getItem("ORGID");
    const club_id = localStorage.getItem("ClubID");
    if (!token) return;

    try {
      setLoading(true);
      const response = await fetch(`${baseurl}/practice/weak-students`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id: USERID, org_id: org_id, club_id: club_id }),
      });

      const res = await response.json();
      if (res?.status_code === 200) {
        const weakData = res.data || [];
        setData(weakData);
        // Collapse all modules by default
        setExpandedModules(new Set());
        setExpandedTopics(new Set());
      }
    } catch (err) {
      console.error("Error fetching weak students data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWeakStudents();
  }, []);

  const toggleModule = (moduleId) => {
    const set = new Set(expandedModules);
    if (set.has(moduleId)) {
      set.delete(moduleId);
    } else {
      set.add(moduleId);
    }
    setExpandedModules(set);
  };

  const toggleTopic = (topicId) => {
    const set = new Set(expandedTopics);
    if (set.has(topicId)) {
      set.delete(topicId);
    } else {
      set.add(topicId);
    }
    setExpandedTopics(set);
  };

  const handleCollapseAllModules = () => {
    if (expandedModules.size > 0) {
      setExpandedModules(new Set());
      setExpandedTopics(new Set());
    } else {
      const allModuleIds = new Set(data.map((m) => m.module_id));
      setExpandedModules(allModuleIds);

      const allTopicIds = new Set();
      data.forEach((m) => {
        m.topics?.forEach((t) => {
          allTopicIds.add(t.topic_id);
        });
      });
      setExpandedTopics(allTopicIds);
    }
  };

  const fetchAiId = async (topicID) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    if (!token) return null;
    try {
      const response = await fetch(`${baseurl}/userlessons_ai/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          topic_id: topicID,
        }),
      });
      if (response.ok) {
        const resData = await response.json();
        return resData?.data?.[0]?.ai_id ?? null;
      }
    } catch (error) {
      console.error("Error fetching AI ID:", error);
    }
    return null;
  };

  const checkActiveSession = async (ctx) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    if (!token) return null;
    try {
      const response = await fetch(`${baseurl}/practice/active-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          User_ID: userId,
          main_topic_id: ctx.main_topic_id,
          topic_id: ctx.topic_id,
          ai_id: ctx.ai_id,
          mapped_skills: [
            {
              label: ctx.skill_name,
              skill_id: ctx.skill_id,
              skill_name: ctx.skill_name,
              value: ctx.skill_id,
            },
          ],
        }),
      });
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.error("Error checking active session:", error);
    }
    return null;
  };

  const handlePracticeClick = async (module, topic, sub, skill) => {
    const aiId = await fetchAiId(topic.topic_id);
    if (!aiId) {
      alert("AI not initialized for this topic.");
      return;
    }
    const ctx = {
      ai_id: aiId,
      main_topic_id: module.module_id,
      topic_id: topic.topic_id,
      topic_name: topic.topic_name,
      subtopic_title: sub.sub_topic_name,
      skill_id: skill.skill_id,
      skill_name: skill.skill_name,
    };
    const assessment = await checkActiveSession(ctx);
    setSelectedPracticeContext(ctx);
    setLastAssessmentData(assessment);
    
    const hasSession = Boolean(assessment?.session_status);
    setPopupText(
      hasSession
        ? "Do you want to continue with your paused assessment?"
        : "Are you sure you want to start a practice session?"
    );
    setShowPopup(true);
  };

  const handlePopupYes = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    const ctx = selectedPracticeContext;
    if (!ctx) {
      setShowPopup(false);
      return;
    }
    navigate("/practice", {
      state: {
        ai_id: ctx.ai_id,
        continue: hasActiveSession,
        page_reload: true,
        main_topic_id: ctx.main_topic_id,
        topic_id: ctx.topic_id,
        topic_name: ctx.topic_name,
        subtopic_title: ctx.subtopic_title,
        subtopic_title_md: ctx.subtopic_title,
        skill_id: ctx.skill_id,
        skill_name: ctx.skill_name,
        mapped_skills: [
          {
            label: ctx.skill_name,
            skill_id: ctx.skill_id,
            skill_name: ctx.skill_name,
            value: ctx.skill_id,
          },
        ],
        fromTrouble: true,
      },
    });
    setShowPopup(false);
  };

  const handlePopupNo = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    const ctx = selectedPracticeContext;
    if (hasActiveSession && ctx) {
      navigate("/practice", {
        state: {
          ai_id: ctx.ai_id,
          continue: false,
          page_reload: true,
          main_topic_id: ctx.main_topic_id,
          topic_id: ctx.topic_id,
          topic_name: ctx.topic_name,
          subtopic_title: ctx.subtopic_title,
          subtopic_title_md: ctx.subtopic_title,
          skill_id: ctx.skill_id,
          skill_name: ctx.skill_name,
          mapped_skills: [
            {
              label: ctx.skill_name,
              skill_id: ctx.skill_id,
              skill_name: ctx.skill_name,
              value: ctx.skill_id,
            },
          ],
          fromTrouble: true,
        },
      });
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  // Filter nested data structure by search query
  const filteredData = data.map((mod) => {
    if (!searchTerm.trim()) return mod;
    const query = searchTerm.toLowerCase();

    const filteredTopics = mod.topics?.map((topic) => {
      const topicMatches = topic.topic_name.toLowerCase().includes(query);

      const filteredSubTopics = topic.sub_topics?.map((sub) => {
        const subTopicMatches = sub.sub_topic_name.toLowerCase().includes(query);

        const filteredSkills = sub.skills?.filter((skill) => {
          return (
            skill.skill_name.toLowerCase().includes(query) ||
            topicMatches ||
            subTopicMatches
          );
        });

        if (filteredSkills?.length > 0) {
          return { ...sub, skills: filteredSkills };
        }
        return null;
      }).filter(Boolean);

      if (filteredSubTopics?.length > 0 || topicMatches) {
        return { ...topic, sub_topics: filteredSubTopics || [] };
      }
      return null;
    }).filter(Boolean);

    if (filteredTopics?.length > 0 || mod.module_name.toLowerCase().includes(query)) {
      return { ...mod, topics: filteredTopics || [] };
    }
    return null;
  }).filter(Boolean);

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      const matchingModuleIds = new Set();
      const matchingTopicIds = new Set();

      filteredData.forEach((mod) => {
        matchingModuleIds.add(mod.module_id);
        mod.topics?.forEach((topic) => {
          matchingTopicIds.add(topic.topic_id);
        });
      });

      setExpandedModules(matchingModuleIds);
      setExpandedTopics(matchingTopicIds);
    } else {
      setExpandedModules(new Set());
      setExpandedTopics(new Set());
    }
  }, [searchTerm, data]);

  const hasActiveSession = Boolean(lastAssessmentData?.session_status);

  return (
    <div className={style.container}>
      {loading ? (
        <Loader />
      ) : (
        <div className={style.focusZoneSection}>
          {/* Header Red Banner */}
          <div className={style.headerBanner}>
            <button className={style.backArrowButton} onClick={() => navigate(-1)}>
              <img src={redBackArrow} alt="" />
            </button>
            <div className={style.headerText}>
              <h2>Focus Zones</h2>
              <p>Let's revisit the skills that need a bit more attention.</p>
            </div>
            <img src={TargetIcon} alt="" className={style.bannerTarget} />
          </div>

          {data.length === 0 ? (
            <div className={style.noGapsCard}>
              <div className={style.noGapsLeft}>
                <h1 className={style.noGapsTitle}>No skills gaps found!</h1>
                <p className={style.noGapsSubtitle}>Your understanding so far is absolutely flawless.</p>
                <p className={style.noGapsDescription}>
                 Stay focused as you tackle the next topics!
                </p>
                <button className={style.goModulesButton} onClick={() => navigate("/new/learnings")}>
                  Back to Modules
                </button>
              </div>
              <div className={style.noGapsRight}>
                <img src={Study} alt="Study illustration" className={style.studyImage} />
              </div>
            </div>
          ) : (
            <>
              {/* Search and Action Row */}
              <div className={style.actionRow}>
                <div className={style.searchWrapper}>
                  <input
                    type="text"
                    placeholder="Search skill"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={style.searchInput}
                  />
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={style.searchIcon}>
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </div>

                <button className={style.collapseButton} onClick={handleCollapseAllModules}>
                  <img
                    src={expandedModules.size > 0 ? collapse : expand}
                    alt=""
                    className={style.collapseIcon}
                  />
                  <p>{expandedModules.size > 0 ? "Collapse All Modules" : "Expand All Modules"}</p>
                </button>
              </div>

              {/* Modules List */}
              <div className={style.modulesList}>
                {filteredData.length === 0 ? (
                  <div className={style.noDataCard}>
                    <p>No weak skills match your search.</p>
                  </div>
                ) : (
                  filteredData.map((module) => (
                    <div key={module.module_id} className={style.moduleCard}>
                      {/* Module Header */}
                      <div className={style.moduleHeader} onClick={() => toggleModule(module.module_id)}>
                        <div className={style.moduleHeaderLeft}>
                          <span className={style.moduleNumberBox}>
                            {module.module_number || module.module_name?.match(/\d+/)?.[0] || "1"}
                          </span>
                          <h3>{module.module_name?.replace(/Module \d+\s*:\s*/, "")}</h3>
                        </div>
                        <div className={style.moduleHeaderRight}>
                          <img src={BookIcon} alt="" />
                          {expandedModules.has(module.module_id) ? (
                            <BsChevronUp className={style.chevronIcon} />
                          ) : (
                            <BsChevronDown className={style.chevronIcon} />
                          )}
                        </div>
                      </div>

                      {/* Expanded Module Topics */}
                      {expandedModules.has(module.module_id) && (
                        <div className={style.moduleContent}>
                          {module.topics?.map((topic) => (
                            <div key={topic.topic_id} className={style.topicBlock}>
                              <div className={topic.sub_topics?.some(s => s.skills?.length > 0) ? style.topicHeader : style.topicHeader} onClick={() => toggleTopic(topic.topic_id)}>
                                <p>{topic.topic_number}: {topic.topic_name}</p>
                                <div className={topic.sub_topics?.some(s => s.skills?.length > 0) ? style.topicHeaderRight : style.topicHeaderRight}>
                                  <img src={BookIcon} alt="" />
                                  {expandedTopics.has(topic.topic_id) ? (
                                    <BsChevronUp className={style.chevronIconSmall} />
                                  ) : (
                                    <BsChevronDown className={style.chevronIconSmall} />
                                  )}
                                </div>
                              </div>

                              {/* Expanded Topic Skills */}
                              {expandedTopics.has(topic.topic_id) && (
                                <div className={style.topicSkillsList}>
                                  {topic.sub_topics?.map((sub) =>
                                    sub.skills?.map((skill, sIdx) => {
                                      const total = skill.total_mark || 50;
                                      const scored = skill.mark_scored || 0;
                                      const percent = Math.max(0, Math.min(100, Math.round((scored / total) * 100)));

                                      return (
                                        <div key={skill.skill_id} className={style.skillRow}>
                                          <div className={style.skillInfoBlock}>
                                            <span className={style.subTopicLabel}>Sub topic : {sub.sub_topic_name}</span>
                                            <h4 className={style.skillName}>{skill.skill_name}</h4>
                                            <div className={style.progressContainer}>
                                              <div className={style.progressBarBg}>
                                                <div
                                                  className={style.progressBarFill}
                                                  style={{ width: `${percent}%` }}
                                                />
                                              </div>
                                              <span className={style.progressPercent}>{percent}%</span>
                                            </div>
                                          </div>
                                          <button
                                            className={style.practiceButton}
                                            onClick={() => handlePracticeClick(module, topic, sub, skill)}
                                          >
                                            Practice
                                          </button>
                                        </div>
                                      );
                                    })
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* Confirmation Popup */}
      {showPopup && (
        <>
          <div className={style.popupOverlay} onClick={handlePopupClose}></div>
          <div className={style.popup}>
            {hasActiveSession && (
              <button
                type="button"
                className={style.popupCloseButton}
                onClick={handlePopupClose}
                aria-label="Close"
              >
                <IoClose />
              </button>
            )}
            <div className={style.popupText}>
              <p>{popupText}</p>
              {hasActiveSession && (
                <span>You paused on the practice test sub-topic</span>
              )}
            </div>
            <div className={style.popupButtonGroup}>
              <button className={style.noButton} onClick={handlePopupNo}>
                {hasActiveSession ? "No, start again please" : "No"}
              </button>
              <button className={style.yesButton} onClick={handlePopupYes}>
                Yes
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FocusZone;
